import { ConnectionState } from "./types";

export const defineConnectionState = (state: ConnectionState): ConnectionState => state;
